import ConductConfig from "@/views/configs/conduct/index.vue";

export default [
  {
    path: "conduta",
    name: "Configuração Conduta",
    component: ConductConfig,
  },
];
